var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aviation"},[_c('div',{staticClass:"flights-table-wrapper"},[_c('AppDataTable',{attrs:{"tableName":"flights","tableIcon":"head-aviation-icon.svg","dataProviderFunc":_vm.dataProvider,"exportUrl":"/aviation/export","action":_vm.tableAction}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }